import * as React from "react";
import { Heading } from "../typography/heading/heading.mjs";
const categoryHeadingBEM = (className) => {
  const classArray = ["product-comparison__category-heading", "h4", "text-left"];
  if (className) {
    classArray.push(className);
  }
  return classArray.join(" ");
};
const CategoryHeading = (props) => {
  const { label } = props;
  return /* @__PURE__ */ React.createElement(Heading, { element: "h2", className: categoryHeadingBEM(typeof label === "string" ? void 0 : "text-size-normal") }, /* @__PURE__ */ React.createElement("span", { className: "product-comparison__category-heading-content" }, label));
};
export {
  CategoryHeading
};
